import { ZiroSelectOption } from '../../../../forms/fields/select/ziro-select.component';

export enum PrivilegeType {
  USER = 'USER',
  GROUP = 'GROUP',
}

export enum PrivilegeRole {
  GLOBAL_ADMINISTRATOR = 'GLOBAL_ADMINISTRATOR',
  TENANT_ADMINISTRATOR = 'TENANT_ADMINISTRATOR',
  CUSTOM = 'CUSTOM',
}

export enum PrivilegeScope {
  GLOBAL = 'GLOBAL',
  TENANT = 'TENANT',
}

export interface Privileges {
  teamsUserManagement: boolean;
  resourceAccountManagement: boolean;
  autoAttendantManagement: boolean;
  callQueueManagement: boolean;
  emergencyLocationManagement: boolean;
  configurationReports: boolean;
  auditReports: boolean;
  cdrReports: boolean;
  migration: boolean;
  automation: boolean;
}

export enum PrivilegeRestriction {
  FULL_ACCESS = 'FULL_ACCESS',
  PARTIAL_ACCESS = 'PARTIAL_ACCESS',
}

interface AbstractPrivilegesFormData extends Privileges {
  type: PrivilegeType;
  role: PrivilegeRole;
}

interface AbstractPrivilegeScopeFormData {
  scope: PrivilegeScope;
}

interface TenantPrivilegesFormData extends AbstractPrivilegeScopeFormData {
  scope: PrivilegeScope.TENANT;
  teamsUserManagementRestrictedDialPlanGroups: ZiroSelectOption[];
  teamsUserManagementRestrictedDialPlanGroupsAccess: PrivilegeRestriction;
}

interface GlobalPrivilegesFormData extends AbstractPrivilegeScopeFormData {
  scope: PrivilegeScope.GLOBAL;
}

interface UserPrivilegesFormData extends AbstractPrivilegesFormData {
  type: PrivilegeType.USER;
  upn: string;
}

interface GroupPrivilegesFormData extends AbstractPrivilegesFormData {
  type: PrivilegeType.GROUP;
  displayName: string;
  tenantGuid: string;
}

export type UserTenantPrivilegesFormData = UserPrivilegesFormData & TenantPrivilegesFormData;
export type GroupTenantPrivilegesFormData = GroupPrivilegesFormData & TenantPrivilegesFormData;
export type UserGlobalPrivilegesFormData = UserPrivilegesFormData & GlobalPrivilegesFormData;
export type GroupGlobalPrivilegesFormData = GroupPrivilegesFormData & GlobalPrivilegesFormData;
export type PrivilegesFormData =
  | UserTenantPrivilegesFormData
  | GroupTenantPrivilegesFormData
  | UserGlobalPrivilegesFormData
  | GroupGlobalPrivilegesFormData;
